export default "__VITE_ASSET__CGuo$$Dz__"